import  { Component } from "react";
import { Card, Row, Col, Tab, Tabs, Spinner, Button, Alert } from "react-bootstrap";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import { getCurrentUser, formataDataHoraExibicao } from '../../common/utils';
import { getConfig } from "../../common/config";
import { FaDownload, FaExclamationTriangle } from "react-icons/fa";

class TermosMedico extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loadingPdf: {
                termo: true,
                regulamento: true,
                privacidade: true,
                cookies: true
            },
            titulo_pagina: "Termos e Políticas",
            programa_dados: {},
            prestador_dados: {},
            // Termos da plataforma que o medico efetivamente aceitou (com PDF + data do aceite)
            termosAceitos: [],
            loadingDados: true,
            erro: ""
        };
    }

    // Busca os termos de plataforma JA ACEITOS pelo medico logado para o programa atual.
    carregaTermosAceitos = async (programa_id) => {
        const dados_usuario = getCurrentUser();
        const categoria = dados_usuario['prestador_categoria'] || '';
        try {
            const resp = await api.get(`/termos-plataforma/meus-aceitos/?programa=${programa_id}&categoria=${categoria}`);
            this.setState({ termosAceitos: Array.isArray(resp.data) ? resp.data : [] });
        } catch (error) {
            console.error('Erro ao carregar termos aceitos da plataforma:', error);
        }
    };

    componentDidMount() {
        const dados_user = getCurrentUser();
        let id = '';

        if (dados_user['tipo_usuario'] === 'prestador') {
            id = dados_user['prestador_id'];
        } else {
            this.props.router.navigate("/home");
            return;
        }

        api.get(`/pessoas/prestadores/${id}`)
            .then(response => {
                this.setState({
                    prestador_dados: response.data,
                });
            })
            .catch(error => {
                console.error('Erro ao consultar dados do prestador:', error);
            });

        this.carregaDadosPrograma();
    }

    carregaDadosPrograma = async () => {
        let dados_usuario = getCurrentUser();
        
        let programa_id = dados_usuario['ambiente_programa_id'];

        if (!programa_id && this.props.router?.params?.id) {
            programa_id = this.props.router.params.id;
        }

        this.setState({ loadingDados: true });

        if (!programa_id && dados_usuario['tipo_usuario'] === 'prestador') {
            try {
                const prestador_id = dados_usuario['prestador_id'];
                // Busca os vinculos do prestador para descobrir o programa
                const responseVinculos = await api.get(`/programas/prestadores/?prestador_id=${prestador_id}`);
                
                if (responseVinculos.data && responseVinculos.data.results && responseVinculos.data.results.length > 0) {
                    // Pega o ID do primeiro programa encontrado
                    programa_id = responseVinculos.data.results[0].programa_id;
                }
            } catch (error) {
                console.error("Erro ao buscar vínculos do prestador:", error);
            }
        }

        if (programa_id) {
            // Carrega termos aceitos E dados do programa em paralelo, mas so libera a tela quando
            // AMBOS terminarem. Senao as abas renderizam antes dos aceitos chegarem, a aba ativa
            // inicial aponta pra uma aba que some quando os aceitos chegam, e a tela fica sem PDF
            // (so aparecia ao dar refresh).
            try {
                const [, response] = await Promise.all([
                    this.carregaTermosAceitos(programa_id),
                    api.get(`/programas/${programa_id}/`)
                ]);
                this.setState({
                    programa_dados: response.data,
                    loadingDados: false
                });
            } catch (error) {
                console.error('Erro ao carregar dados do programa atual:', error);
                this.setState({
                    loadingDados: false,
                    erro: "Erro ao carregar dados do programa."
                });
            }
        } else {
             console.warn("Nenhum programa identificado para este usuário.");
             this.setState({ 
                 loadingDados: false,
                 erro: "Nenhum programa vinculado encontrado."
             });
        }
    };

    handlePdfLoaded = (key) => {
        this.setState((prev) => ({
            loadingPdf: { ...prev.loadingPdf, [key]: false }
        }));
    };

    renderPdfCard = (title, url, key, dataAceite = null) => {
        const { loadingPdf } = this.state;

        if (!url) {
            return (
                <Card className="cardDestaque mb-4">
                    <Card.Header>
                        <div>{title}</div>
                    </Card.Header>
                    <Card.Body>
                        <Alert variant="warning" className="m-0">
                            <FaExclamationTriangle className="me-2" />
                            Este documento não foi cadastrado para este programa.
                        </Alert>
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="cardDestaque mb-4">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold">{title}</div>
                    <div>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            href={url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            title="Baixar ou Visualizar em nova aba"
                        >
                            <FaDownload className="me-1"/> Baixar / Visualizar
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body style={{ padding: 0 }}>
                    {loadingPdf[key] && (
                        <div style={{ padding: 20, textAlign: "center" }}>
                            <Spinner animation="border" variant="primary" size="sm" />
                            <p className="mt-2 text-muted">Carregando documento...</p>
                        </div>
                    )}

                    <div style={{ width: "100%", height: "75vh", borderTop: "1px solid #eee" }}>
                        <iframe 
                            title={title} 
                            src={url} 
                            style={{ width: "100%", height: "100%", border: "none" }} 
                            onLoad={() => this.handlePdfLoaded(key)}
                        />
                    </div>
                </Card.Body>
                <Card.Footer className="text-muted text-end">
                   <small>
                       {dataAceite ? (
                           <>Aceito em: <strong>{formataDataHoraExibicao(dataAceite)}</strong></>
                       ) : this.state.prestador_dados.data_aceite_termo ? (
                           <>Aceito em: <strong>{formataDataHoraExibicao(this.state.prestador_dados.data_aceite_termo)}</strong></>
                       ) : (
                           <>Documento disponível para consulta</>
                       )}
                   </small>
                </Card.Footer>
            </Card>
        );
    };

    render() {
        const { programa_dados, loadingDados, erro } = this.state;

        // Rotulo configuravel do termo de plataforma aceito: alguns programas (ex.: Chiesi) pedem que
        // o medico veja como "Regulamento do Programa" em vez de "Termo de Uso Aceito".
        const labelTermoAceito = getConfig(programa_dados.configuracoes, 'cadastro_medico.label_termo_aceito', '');
        const tituloTermoAceitoTab = labelTermoAceito || 'Termo de Uso Aceito';

        if (loadingDados) {
            return (
                <div className="text-center mt-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </Spinner>
                    <p className="mt-2">Carregando termos e políticas...</p>
                </div>
            );
        }

        if (erro) {
             return (
                <div className="mt-4">
                    <Alert variant="danger">
                        <FaExclamationTriangle className="me-2" />
                        {erro}
                    </Alert>
                </div>
            );
        }

        const tabsValidas = [];

        const termosAceitos = this.state.termosAceitos || [];
        if (termosAceitos.length > 0) {
            // Ha termo de plataforma aceito: exibe SOMENTE ele (esconde todos os documentos do
            // programa — termos, regulamento, privacidade e cookies).
            tabsValidas.push("termoAceito");
        } else {
            if (programa_dados.termos_programa_medicos) {
                tabsValidas.push("dadosTermoMedico");
            }
            if (programa_dados.regulamento_programa) {
                tabsValidas.push("politicaRegulamento");
            }
            if (programa_dados.aviso_privacidade) {
                tabsValidas.push("politicaPrivacidade");
            }
            if (programa_dados.politica_cookies) {
                tabsValidas.push("politicaCookies");
            }
        }

        const defaultTab = tabsValidas[0] || null;

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>

                <Tabs defaultActiveKey={defaultTab} id="tabs-termo" className="aditus-tabs mb-3">
                    {termosAceitos.length > 0 && (
                    <Tab eventKey="termoAceito" title={tituloTermoAceitoTab}>
                        <div className="mt-3">
                            {/* Termo(s) da plataforma efetivamente aceito(s) pelo medico (com PDF + data do aceite) */}
                            {/* Comprovante quando houver: e o PDF com as respostas marcadas e a
                                data do aceite. Sem ele (aceites antigos), volta ao termo em branco. */}
                            {termosAceitos.map((t) => (
                                this.renderPdfCard(
                                    labelTermoAceito
                                        ? `${labelTermoAceito}${t.versao ? ` (v${t.versao})` : ''}`
                                        : (t.titulo ? `${t.titulo}${t.versao ? ` (v${t.versao})` : ''}` : 'Termo de Uso Aceito'),
                                    t.pdf_comprovante || t.arquivo_pdf_url,
                                    `aceito_${t.id}`,
                                    t.data_consentimento
                                )
                            ))}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.termos_programa_medicos && termosAceitos.length === 0 && (
                    <Tab eventKey="dadosTermoMedico" title="Termos do Programa">
                        <div className="mt-3">
                            {/* Carrega: termos_programa_medicos */}
                            {this.renderPdfCard("Termos do Programa (Médicos)", programa_dados.termos_programa_medicos, "termo")}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.regulamento_programa && termosAceitos.length === 0 && (
                    <Tab eventKey="politicaRegulamento" title="Regulamento do Programa">
                        <div className="mt-3">
                            {/* Carrega: regulamento_programa */}
                            {this.renderPdfCard("Regulamento do Programa", programa_dados.regulamento_programa, "regulamento")}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.aviso_privacidade && termosAceitos.length === 0 && (
                    <Tab eventKey="politicaPrivacidade" title="Aviso de Privacidade">
                        <div className="mt-3">
                            {/* Carrega: aviso_privacidade */}
                            {this.renderPdfCard("Aviso de Privacidade", programa_dados.aviso_privacidade, "privacidade")}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.politica_cookies && termosAceitos.length === 0 && (
                    <Tab eventKey="politicaCookies" title="Políticas de Cookies">
                        <div className="mt-3">
                            {/* Carrega: politica_cookies */}
                            {this.renderPdfCard("Políticas de Cookies", programa_dados.politica_cookies, "cookies")}
                        </div>
                    </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(TermosMedico);
